import client from '../../client';
import type {
  IGetAsCsTemplateListParams,
  ICreateAsCsTemplateParams,
  ICreateAsCsTemplateFieldParams,
  ICreateAsCsTemplateMappingParams,
} from './types';

export const aiAgentTemplateApis = {
  getAsCsTemplateList: (data: IGetAsCsTemplateListParams) => client.get(`/document/template`, { params: data }),
  createAsCsTemplate: (data: ICreateAsCsTemplateParams) => client.post(`/document/template`, data),
  createAsCsTemplateField: (data: ICreateAsCsTemplateFieldParams) => client.post(`/document/template/field`, data),
  getAsCsTemplate: (templateId: number) => client.get(`/document/template/${templateId}`),
  createAsCsTemplateMapping: (data: ICreateAsCsTemplateMappingParams) => client.post(`/document/template/field/mapping`, data),
  deleteAsCsTemplate: (templateId: number) => client.delete(`/document/template/${templateId}`),
  getTemplateColumnInfo: () => client.get('/document/template/column-info'),
};
